/* eslint-disable */

/** unique or primary key constraints on table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessConstraint {
  /** unique or primary key constraint on columns "type" */
  SnFormatUniquenessPkey = 'sn_format_uniqueness_pkey'
}

export enum ArgoSnFormatUniquenessEnum {
  /** Globally unique */
  G = 'g',
  /** Non-Unique */
  N = 'n',
  /** Unique within this format */
  U = 'u'
}

/** select columns of table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

